const translations = {
    save: 'Save Controller',
    saveError: 'Something went wrong. Please try again.',
    title: 'Add Controller'
};

export default translations;
